import { AxiosInstance } from 'axios';
import axios from 'axios';
import * as moment from 'moment';

import { IPossibleFilters, IUrl } from 'src/views/Links/types';

import { insertId } from '../insertId';
import createQuery from '../links/utils/createQuery';

const toResponse = (
  response: any,
  market: string,
  linksPerPage: number,
  marketParameterName: string
) => {
  if (!response.success || !response.result || !response.result.hits) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${response.errorMessage}`
    );
  }

  const links = response.result.hits.hits.map((el: any) => {
    const data = el._source;
    const linkParameters = data.parameters.map((p: any) => ({
      name: p.Name,
      value: p.Value,
      group: p.ParameterGroup || 'GeneralInformation',
    }));

    linkParameters.unshift({
      name: marketParameterName,
      value: market,
      group: 'GeneralInformation',
    });

    return {
      id: data.id,
      visibleId: data.UniqueLinkId,
      created: moment(data.CreatedOn).utc().format('DD.MM.YYYY H:mm'),
      parameters: linkParameters,
      urls: data.urls
        .map(
          (url: any): IUrl => ({
            id: url.id,
            url: url.Url,
            shortUrl: url.ShortUrl,
            canShorten: url.CanShorten,
            canCopy: url.CanCopy,
            isMain: url.IsMainUrl,
            showQR: url.ShowQrCode,
          })
        )
        .sort((a: IUrl, b: IUrl) => {
          if ((a.isMain && b.isMain) || (!a.isMain && !b.isMain)) {
            return 0;
          }
          return a.isMain && !b.isMain ? -1 : 1;
        }),
    };
  });

  return {
    links,
    pageCount: Math.ceil(response.result.hits.total / linksPerPage),
  };
};

export default (api: AxiosInstance, url: string) =>
  (
    id: number,
    options: IPossibleFilters,
    market: string,
    marketParameterName: string
  ) => {
    const urlWithId = insertId(url, id);
    const cancel = axios.CancelToken;
    const source = cancel.source();
    return {
      getData: async () => {
        const response = await api.post(urlWithId, createQuery(options), {
          cancelToken: source.token,
        });
        if (!response) {
          return Promise.reject();
        }
        return toResponse(
          response.data,
          market,
          options.linksPerPage ? options.linksPerPage : 10,
          marketParameterName
        );
      },
      cancel: source.cancel,
    };
  };



// WEBPACK FOOTER //
// ./src/services/api/linkUpload/getBulkUpload.ts